import {createReducer} from 'util/redux/createReducer'
import {memoAddAction, memoRemoveAction, memoToggleAction} from 'module/Memo/action/MemoAction'
import {Memorizable, MemorizableAttributes} from 'module/Memo/type/Memorizable'
import {pick} from 'lodash'
import {MemoActionPayload} from 'module/Memo/type/MemoActionPayload'

function getElement(element: MemoActionPayload['element'] | null | undefined) {
	if (!element || !element.value && element.value !== 0) return null
	const e = {
		...pick(element, ...MemorizableAttributes),
		value: (element.value + '').trim(),
		label: typeof element.label === 'string' ? element.label : undefined,
	}
	if (!e.value) return null
	return e
}

type MemoReducerStateType = { [memoKey in string]: Memorizable[] }

const reducer = createReducer<MemoReducerStateType>({}, builder => builder
	.addCase(memoAddAction, (state, {payload: {memoKey, memoSize, element}}) => {
		const e = getElement(element)
		if (!e || e.disabled || e.hidden) return state

		const oldCollection = (state[memoKey] || []).filter(x => x.value !== e.value)
		return ({
			...state,
			[memoKey]: [e, ...oldCollection].slice(0, memoSize),
		})
	})
	.addCase(memoRemoveAction, (state, {payload: {memoKey, element}}) => ({
		...state,
		[memoKey]: state[memoKey]?.filter(({value}) => element.value != value),
	}))
	.addCase(memoToggleAction, (state, {payload: {memoKey, memoSize, element}}) => {
		const e = getElement(element)
		if (!e || e.disabled || e.hidden) return state

		let found = false
		let collection = (state[memoKey] || []).filter(x => {
			if (x.value != e.value) {
				return true
			} else {
				found = true
				return false
			}
		})
		if (!found) {
			// not found, add
			collection = [e, ...collection].slice(0, memoSize)
		}
		return ({
			...state,
			[memoKey]: collection,
		})
	}),
)

export const MemoReducerNS = {Memo: reducer}
export type MemoStateType = { Memo?: ReturnType<typeof MemoReducerNS.Memo> }